// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"179":"main","1858":"person-edit","6845":"profile","8790":"election-detail"}[chunkId] + "." + {"179":"0333d692","1858":"20b61f7e","6845":"d699e9f5","8790":"f2736fae"}[chunkId] + ".css";
};